<template>
    <div class="row justify-content-center">
        <div class="col-lg-6 card-wrapper metadata">
            <card>
                <!-- Card header -->



                <div class="card-body">
                    <!-- Card body -->
                    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
                        <form class="needs-validation" @submit.prevent="handleSubmit(firstFormSubmit)">
                            <!-- Input groups with icon -->




                            <b-row>
                                <b-col md="8"><label class="form-control-label">Title of your art book</label></b-col>
                                <b-col md="4" class="text-right">
                                    <span class="badge badge-info badge-circle text-white" @click="showHint('title');">
                                        <i class="fa fa-question"></i>
                                    </span>
                                </b-col>

                                <b-col md="12">
                                    <base-input prepend-icon="fas fa-book" placeholder="Title"  name="Title"
                                        rules="required" v-model="currentPhotoBook.title"></base-input>
                                        
                                </b-col>

                                <b-col md="8"><label class="form-control-label">Subtitle of your art book</label></b-col>
                                <b-col md="4" class="text-right">
                                    <span class="badge badge-info badge-circle text-white" @click="showHint('subtitle');">
                                        <i class="fa fa-question"></i>
                                    </span>
                                </b-col>

                                <b-col md="12">
                                    <base-input prepend-icon="fas fa-book" placeholder="Subtitle"
                                        name="Subtitle" rules="required"
                                        v-model="currentPhotoBook.subtitle"></base-input>
                                </b-col>

                                <b-col md="8"><label class="form-control-label">Blurb for your art book (between 300 and 800 characters)</label></b-col>
                                <b-col md="4" class="text-right">
                                    <span class="badge badge-info badge-circle text-white" @click="showHint('blurb');">
                                        <i class="fa fa-question"></i>
                                    </span>
                                </b-col>


                                <b-col md="12">
                                    <!-- base-input label="Blurb for your art book" </base-input> -->
                                    <html-editor v-model="currentPhotoBook.blurb" :maxchars="800"></html-editor>
                                        <!-- textarea class="form-control" name="Blurb" rules="required|alpha_dash"
                                            v-model="currentPhotoBook.bio" rows="10"></textarea -->
                                    
                                </b-col>




                                <!-- b-col md="12" v-if="!currentPhotoBook.do_blurb">
                                    <base-input label="Blurb">
                                        <textarea class="form-control" label="false" name="Blurb" rules="required|alpha_dash"
                                            v-model="currentPhotoBook.blurb" rows="10"></textarea>
                                    </base-input>
                                </b-col -->

                                <!-- b-col md="12">
                                    <b-form-checkbox class="mb-3" v-model="currentPhotoBook.do_blurb">
                                        I have no idea about texting, please do the blurb for me
                                    </b-form-checkbox>
                                </b-col -->

                                <b-col md="8"><label class="form-control-label">Your short bio (between 300 and 800 characters)</label></b-col>
                                <b-col md="4" class="text-right">
                                    <span class="badge badge-info badge-circle text-white" @click="showHint('biography');">
                                        <i class="fa fa-question"></i>
                                    </span>
                                </b-col>

                                <b-col md="12">
                                    <!-- base-input label="Your biography"></base-input -->
                                    <html-editor v-model="currentPhotoBook.bio" :maxchars="800"></html-editor>
                                        <!-- textarea class="form-control" name="Bio" rules="required|alpha_dash"
                                            v-model="currentPhotoBook.bio" rows="10"></textarea -->
                                    
                                </b-col>

                                <b-col md="8"><label class="form-control-label">Keywords</label></b-col>
                                <b-col md="4" class="text-right">
                                    <span class="badge badge-info badge-circle text-white" @click="showHint('keywords');">
                                        <i class="fa fa-question"></i>
                                    </span>
                                </b-col>

                                <b-col md="12">
                                    <base-input>
                                        <tags-input v-model="currentPhotoBook.keywords" placeholder="Add new Keyword"
                                            class="test"></tags-input>
                                    </base-input>
                                </b-col>

                                <b-col md="12">
                                    <base-input label="Orientation">

                                        <b-form-radio-group v-model="currentPhotoBook.orientation">
                                            <div>
                                                <b-form-radio value="portrait" name="chacked" class="mb-3">
                                                    portrait
                                                </b-form-radio>
                                                <b-form-radio value="landscape" name="checked" class="mb-3">
                                                    landscape
                                                </b-form-radio>
                                            </div>
                                        </b-form-radio-group>
                                    </base-input>
                                </b-col>
                                <!--Card Body-->

                            </b-row>

                            <!-- div class="btn-wrapper text-center">

                                <base-button type="primary" class="btn btn-danger" @click="onCancel">
                                    <span class="btn-inner--text">Back</span>
                                </base-button>

                                <base-button type="primary" class="btn btn-success" @click="onProceed"
                                    :disabled="mayProceed">
                                    <span class="btn-inner--text">Next</span>
                                </base-button>

                            </div -->

                        </form>
                    </validation-observer>
                </div>
            </card>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex'
import { Tooltip } from 'element-ui'
import TagsInput from '@/components/Inputs/TagsInput'
import swal from '../../../../services/swal'
import HtmlEditor from '@/components/Inputs/HtmlEditor'

export default {
    name: 's02',
    components: {
        TagsInput,
        [Tooltip.name]: Tooltip,
        swal,
        HtmlEditor,
    },
    methods: {
        onCancel: function () { },
        onProceed: function () { },
        allDataValidated: function () {
                /*
                console.log(this.currentPhotoBook.title);
                console.log(this.currentPhotoBook.subtitle);
                console.log(this.currentPhotoBook.blurb);
                console.log(this.currentPhotoBook.bio);
                console.log(this.currentPhotoBook.orientation);
                console.log(this.currentPhotoBook.keywords);
                */
            if (
                this.currentPhotoBook.title &&
                this.currentPhotoBook.subtitle &&
                this.currentPhotoBook.blurb &&
                this.currentPhotoBook.bio &&
                this.currentPhotoBook.orientation &&
                this.currentPhotoBook.keywords
            ) {

                
                //this.claim.allValidated = true;
                console.log("VALID ENABLING NEXT");
                console.log(this.currentPhotoBook.keywords);
                this.$emit('allowProceed');
                return true;
            }
            this.$emit('denyProceed');
            return false;
        },
        showHint(topic){
            console.log(topic);
            switch(topic){
                case 'title':
                    swal.info('Why do we ask for a title?', 'We need a title in order to list your book in our catalogue.');
                    break;
                case 'subtitle':
                    swal.info('Why do we ask for a Subtitle?', 'We need the subtitle for legal reasons to suppress identical titles. The subtitle is not mandatorily displayed on the fornt cover.');
                break;
                case 'blurb':
                    swal.info('Why do we ask for the blurb?', 'We need the blurb as a short description of your book to be used on our website. It can also be displayed on the back cover. For best results we recommend between 300 and 800 characters.');
                break;
                case 'biography':
                    swal.info('Biography', 'Please tell us something about you. Your short biography will be added to the website, like the blurb. We recommend between 300 and 800 characters.');
                break;
                case 'keywords':
                    swal.info('Keywords', 'Please add at least 3 keywords describing your art book. Example: photography');
                break;
            }
        },
    },
    computed: {
        ...mapGetters({
            currentAccount: 'currentAccount',
            currentPhotoBook: 'currentPhotoBook',
        }), 
    },
    watch: {
        currentPhotoBook: {
            handler:function (newItem) {
                //console.log("DEEPWATCH");//this.doSomethingWith(newItem);
                //this.currentPhotoBook.keywords = this.currentPhotoBook.keywords.join(','); //split(',');
                
                this.allDataValidated();
            },
            deep: true
        },
    },
    mounted() {
        this.$emit('denyProceed');
        this.allDataValidated();
       // swal.error('Test', 'Ihr Foto konnte nicht gelesen werden - achten Sie bitte darauf, dass der Fahrzeugschein möglichst scharf fotografiert wird.');
    }
};
</script>